<kendo-listbox kendoListBoxDataBinding [data]="list" [toolbar]="{ tools: [] }">
    <ng-template kendoListBoxItemTemplate let-dataItem>
        <span (click)="handleActionClick(dataItem)">{{ getName(dataItem) }}</span>
    </ng-template>
</kendo-listbox>